// Position tone tokens (shared between Spielermanager and Tactics).
// All colors are CSS rgba strings — usable from both Tailwind inline styles
// and Konva fill/stroke props.

export interface PositionTone {
  bg: string;
  fg: string;
  ring: string;
}

export const POSITION_TONE: Record<string, PositionTone> = {
  TW: {
    bg: "rgba(255,176,46,0.18)",
    fg: "#ffd28a",
    ring: "rgba(255,176,46,0.55)",
  },
  IV: {
    bg: "rgba(120,170,255,0.18)",
    fg: "#bcd5ff",
    ring: "rgba(120,170,255,0.55)",
  },
  LV: {
    bg: "rgba(120,170,255,0.18)",
    fg: "#bcd5ff",
    ring: "rgba(120,170,255,0.55)",
  },
  RV: {
    bg: "rgba(120,170,255,0.18)",
    fg: "#bcd5ff",
    ring: "rgba(120,170,255,0.55)",
  },
  ZM: {
    bg: "rgba(151,252,0,0.16)",
    fg: "#d6ff8c",
    ring: "rgba(151,252,0,0.55)",
  },
  LM: {
    bg: "rgba(151,252,0,0.16)",
    fg: "#d6ff8c",
    ring: "rgba(151,252,0,0.55)",
  },
  RM: {
    bg: "rgba(151,252,0,0.16)",
    fg: "#d6ff8c",
    ring: "rgba(151,252,0,0.55)",
  },
  LS: {
    bg: "rgba(189,156,255,0.18)",
    fg: "#d8c6ff",
    ring: "rgba(189,156,255,0.55)",
  },
  RS: {
    bg: "rgba(189,156,255,0.18)",
    fg: "#d8c6ff",
    ring: "rgba(189,156,255,0.55)",
  },
  ST: {
    bg: "rgba(255,121,143,0.18)",
    fg: "#ffc1cc",
    ring: "rgba(255,121,143,0.55)",
  },
};

export const NEUTRAL_TONE: PositionTone = {
  bg: "rgba(190,200,210,0.16)",
  fg: "#d5dde6",
  ring: "rgba(190,200,210,0.45)",
};

export function toneOf(pos: string | null | undefined): PositionTone {
  if (!pos) return NEUTRAL_TONE;
  return POSITION_TONE[pos] ?? NEUTRAL_TONE;
}

// Solid-ish variants for tokens drawn on the pitch (need more contrast
// against the green background than the translucent card pills).
export const POSITION_SOLID: Record<string, { fill: string; stroke: string; fg: string }> = {
  TW: { fill: "#ffb02e", stroke: "#7a4a00", fg: "#1a1200" },
  IV: { fill: "#78aaff", stroke: "#0e2a55", fg: "#0a1626" },
  LV: { fill: "#78aaff", stroke: "#0e2a55", fg: "#0a1626" },
  RV: { fill: "#78aaff", stroke: "#0e2a55", fg: "#0a1626" },
  ZM: { fill: "#97fc00", stroke: "#3a5b00", fg: "#0f1a00" },
  LM: { fill: "#97fc00", stroke: "#3a5b00", fg: "#0f1a00" },
  RM: { fill: "#97fc00", stroke: "#3a5b00", fg: "#0f1a00" },
  LS: { fill: "#bd9cff", stroke: "#3a247a", fg: "#10082a" },
  RS: { fill: "#bd9cff", stroke: "#3a247a", fg: "#10082a" },
  ST: { fill: "#ff798f", stroke: "#5a0a1f", fg: "#1f0008" },
};

export const NEUTRAL_SOLID = {
  fill: "#cfd6df",
  stroke: "#2a313a",
  fg: "#10141a",
};

export function solidOf(pos: string | null | undefined) {
  if (!pos) return NEUTRAL_SOLID;
  return POSITION_SOLID[pos] ?? NEUTRAL_SOLID;
}
